export class NoResultsError extends Error {}

// converted from src/Imaios/ZooPaedia/API/Values/Taxon.php rest api props (but with only used props)
export type Taxon = {
  id: number;
  path: string; // example: nodePath /173420/173424/
  name: string;
  url: string;
  rank: string;
  childrenCount: number;
  children: Taxon[] | null;
  caseCount: number;
};

export const fetchTaxonContent = async (url: string): Promise<Document> => {
  const response = await fetch(url, {
    method: "GET",
  });

  if (response.status !== 200) {
    throw new Error(
      `Unexpected response http code '${response.status}' when fetching item url '${url}'.`
    );
  }

  return new DOMParser().parseFromString(await response.text(), "text/html");
};

export async function fetchChildren(childrenUrl): Promise<Taxon[]> {
  const response = await fetch(childrenUrl, {
    method: "GET",
  });

  if (response.status >= 400 || response.redirected === true) {
    throw new Error(
      `Tree view search error with http code '${response.status}'`
    );
  }

  if (response.status === 204) {
    throw new NoResultsError();
  }

  if (response.status !== 200) {
    throw new Error(
      `Unexpected response http code '${response.status}' on tree view search for url '${url}'.`
    );
  }

  return await response.json();
}

export function convertTaxonFromApplication(application: string, rawNodeList: []): [] {
  let convertedNode = [];
  switch (application) {
    case "anatomical":
      convertedNode = rawNodeList.map(
        ({ hash, title, childrenApiUrl, ...rest }) => ({
          id: hash,
          name: title,
          childrenUrl: childrenApiUrl,
          ...rest,
        })
      );
      break;
    case "zoopaedia":
      convertedNode = rawNodeList.map(({ path, ...rest }) => ({
        nodePath: path,
        ...rest,
      }));
      break;
  }
  return convertedNode;
}
